import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "../hooks";
import { getContrastTextColor } from "../utils/colorManager";

interface StepContainerProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

const StepContainer: React.FC<StepContainerProps> = ({
  title,
  description,
  children,
}) => {
  const { theme } = useTheme();
  return (
    <Paper
      sx={{
        width: "33.33%",
        bgcolor: theme.color_secondary,
        borderLeft: 4,
        borderColor: theme.color_primary,
        p: 2,
        mb: 3,
        borderRadius: 1,
      }}
    >
      <Typography
        variant="h6"
        color={getContrastTextColor(theme.color_secondary)}
        fontWeight="bold"
        mb={0.5}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        mb={1}
        color={getContrastTextColor(theme.color_secondary)}
      >
        {description}
      </Typography>
      {children && <Box>{children}</Box>}
    </Paper>
  );
};

export default StepContainer;
